<template>
    <div class="content1">
		<div class="mask" v-if="!show">
			非活动期间，敬请期待
		</div>
		<div class="container" v-if="show">
			<div class="box">
				<img class="luckbj" src="https://static.xunchen.work/image/2026/08/19/1787130205460856.gif"/>
				<div class="frame_view">
					<div class="frame_row">
						<div class="frame_item" :class="'item' + color[0]">
							<img :src="award[0].imagePath"/>
						</div>
						<div class="frame_item" :class="'item' + color[1]">
							<img :src="award[1].imagePath"/>
						</div>
						<div class="frame_item" :class="'item' + color[2]">
							<img :src="award[2].imagePath"/>
						</div>
					</div>
				
					<div class="frame_row">
						<div class="frame_item" :class="'item' + color[7]">
							<img :src="award[7].imagePath"/>
						</div>
						<img class="frame_item" src="@/assets/djcj.png" @click="clickLuck"/>
						<div class="frame_item" :class="'item' + color[3]">
							<img :src="award[3].imagePath"/>
						</div>
					</div>
				
					<div class="frame_row">
						<div class="frame_item" :class="'item' + color[6]">
							<img :src="award[6].imagePath"/>
						</div>
						<div class="frame_item" :class="'item' + color[5]">
							<img :src="award[5].imagePath"/>
						</div>
						<div class="frame_item" :class="'item' + color[4]">
							<img :src="award[4].imagePath"/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
//计数器
var interval = null;
//值越大旋转时间越长  即旋转速度
var intime = 50;
export default {
    data () {
        return {
            activity:{},
			show:false,
            color: [0, 0, 0, 0, 0, 0, 0, 0],
            award:[],
            btnconfirm: '@/assets/djcj.png',//点击图片链接
            Luck: true,//防置重复点击
            luckPosition: 0 ,//停止位置
            exchangeName:'',
            IntegralSum:0,
            weekday:'',
            week: [0,1, 2, 3, 4, 5, 6],
            indeximg:[{
                imagePath:'https://static.xunchen.work/image/net/968dfd0a6d6dd4825737d5be9d9eae9e.jpg'
            }],
        }
    },
    created(){
        let that=this
		var today=new Date().getDay(); 
		switch (today){
			case 0:that.weekday=that.week[0]
			break; 
			case 1:
			case 2:
			case 3:
			case 4:
			case 5:
			case 6:that.weekday=that.week[today]
			break;
		}
        that.$axios.get(process.env.API_HOST+"sso/applets/image/21007/4",'').then((res) => {
            if(res.data.state==200){
                that.indeximg=res.data.data.length>0?res.data.data:[{
                    imagePath:'https://static.xunchen.work/image/net/968dfd0a6d6dd4825737d5be9d9eae9e.jpg'
                }]
            
            }
        }).catch((error) =>{
        });
		// 80332444
		
        that.$axios.get(process.env.API_HOST+"api/vue/marketing/lottery/21007?memberSid=80225574",).then((res) => {
            if(res.data.state==200){
				that.show=true
                that.activity=res.data.data.entity
				that.award=res.data.data.entity.exchangeDetails.sort(that.getlist("sort"))
            }else{
				that.show=false
			}
        }).catch((error) =>{
        });
		that.getIntegralSum()
    },
    methods:{
		getlist(propertyName){
			return function (object1,object2) {
				var value1 = object1[propertyName];
				var value2 = object2[propertyName];
		
				if (value1 < value2) {
					return -1;
				} else if (value1 > value2) {
					return 1;
				} else {
					return 0;
				}
			};
		},
		getIntegralSum(){
			let that=this;
			let form={
				curPage:1,
				memberSid:80332444,
				pageSize:10,
				shopSid:21007,
			}
			that.$axios.post(process.env.API_HOST+"api/promotion/exchangePage?curPage=1&pageSize=10&shopSid=21007&memberSid=80332444").then((res) => {
				if(res.data.state==200){
					that.IntegralSum=res.data.IntegralSum
				}
			}).catch((error) =>{
			});
		},
		clickLuck() {
			//中奖
			var e = this;
			if(e.activity.times==0){
				this.$toast('活动参与达到上限');
				return
			}
			if(e.IntegralSum<e.award[0].expendIntegral){
				this.$toast('积分不足，快去攒积分吧');
				return
			}
			this.$dialog.confirm({
				message: '当前积分:'+e.IntegralSum+'\r\n每次抽奖会消耗'+e.award[0].expendIntegral+'积分',
			}).then(() => {
				console.log(5555)
				if (e.Luck == false) {//防止过度点击
					return;
				}
				e.Luck = false;
				var stoptime = 1000;
				let form={
					memberSid:80332444,
					shopSid:21007,
					psid:e.activity.sid,
				}
				e.$axios.post(process.env.API_HOST+"api/vue/marketing/lottery",form).then((res) => {
					if(res.data.state==200){
						e.activity.times=res.data.data.entity.times
						e.getIntegralSum()
						//清空计时器
						clearInterval(interval);
						var index = 0;
						//循环设置每一项的背景图
						interval = setInterval(function() {
							var c = [0, 0, 0, 0, 0, 0, 0, 0];
							if (index > 7) {
								index = 0;
							}
							c[index] = 1;
							e.color = c;
							index++;
						}, intime);
						setTimeout(function() {
							e.stop(res.data.data.entity.sort-1);
							e.exchangeName=res.data.data.entity.exchangeName
						}, stoptime);
					}
					else{
						e.Luck=true
						e.$toast(res.data.message);
					}
				}).catch((error) =>{
				});
			}).catch(() => {
				
			});
			return
		},
		stop(which) {
			var e = this;
			clearInterval(interval);
			var current = -1;
			var color = e.color;
			for (var i = 0; i < color.length; i++) {
				if (color[i] == 1) {
					current = i;
				}
			}
			var index = current + 1;
			e.stopLuck(which, index, intime, 10);
		},
		stopLuck(which, index, time, splittime) {
			var e = this;
			//值越大出现中奖结果后减速时间越长
			var color = e.color;
			setTimeout(function() {
				//重置前一个位置
				var c = [0, 0, 0, 0, 0, 0, 0, 0];
				if (index > 7) {
					index = 0;
				}
				//当前位置为选中状态
				c[index] = 1;
				e.color = c;
				//如果旋转时间过短或者当前位置不等于中奖位置则递归执行
				//直到旋转至中奖位置
				if (time < 400 || index != which) {
					//越来越慢
					splittime++;
					time += splittime;
					//当前位置+1
					index++;
					e.stopLuck(which, index, time, splittime);
				} else {
					//1秒后显示弹窗
					setTimeout(function() {
						if (e.award[which].exchangeType != 4) {
							let desc=e.award[which].exchangeType==3?'积分':''
							//中奖
							e.$dialog.alert({
								title: '温馨提示',
								message: '恭喜获得'+e.exchangeName+desc,
							}).then(() => {
								e.Luck = true;
							})
						} else {
							//中奖
							e.$dialog.alert({
								title: '温馨提示',
								message: e.exchangeName,
							}).then(() => {
								e.Luck = true;
							})
						}
					}, 1000);
				}
			}, time);
		}
    }
}
</script>

<style>
.content1 {
	/* background:url('http://116.196.116.98:4869/6401fbd7b788e3b782a68925b0bfaed6') no-repeat;
	background-size: cover; */
	background-color: #803ce6;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}
.mask{
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	background: rgba(0,0,0,.6);
	color: #fff;
	z-index: 11;
	font-size: 0.4rem;
	display: flex;
	align-items: center;
	justify-content: center;
}
.container {
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
}
.box{
	width: 6.41rem;
    height: 6.41rem;
	border-radius: 0.5rem;
	box-sizing: border-box;
	margin-top: -0.85rem;
	position: relative;
	z-index: 1;
	transform: scale(0.6);
}
.box .luckbj{
    width: 6.41rem;
    height: 6.41rem;
    position: absolute;
	top: 0;
	left: 0;
    display: block;
}
.box .frame_view {
    width: 6.41rem;
    height: 6.41rem;
    padding: 0.33rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    border-radius: 0.3rem;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
.box .frame_row {
    width: 5.8rem;
    height: 2.02rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.box .frame_item {
    width: 1.9rem;
    height: 1.9rem;
    background-repeat: no-repeat;
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    font-size: 0.2rem;
    border:0.06rem solid rgba(0,0,0,0);
    box-sizing: border-box;
    border-radius: 0.1rem;
    overflow: hidden;
    position: relative;
}
.box img {
    width: 100%;
    height: 100%;
    display: block;	
}
.box .frame_item span {
    font-size: 0.14rem;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
}
.box .item1 {
    color: #000000;
    border:0.06rem solid #ffdb75;
}
.box .item1 img{
	background: #ffdb75;
}
</style>


// WEBPACK FOOTER //
// src/view/luck.vue